module.exports = __webpack_public_path__ + "img/4.905d5e39.png";